import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface SelectionState {
    basicInsurance: number | null;
    specialty: number | null;
    city: number | null;
    specialSpecialty: number | null;

    // added fields
    title: "all" | "matab" | "online";
}

const initialState: SelectionState = {
    basicInsurance: null,
    specialty: null,
    city: null,
    specialSpecialty: null,

    // title fields
    title: "all",
};

const selectionSlice = createSlice({
    name: "selectionSearch",
    initialState,
    reducers: {
        setBasicInsurance: (state, action: PayloadAction<number | null>) => {
            state.basicInsurance = action.payload;
        },
        setSpecialty: (state, action: PayloadAction<number | null>) => {
            state.specialty = action.payload;
        },
        setCity: (state, action: PayloadAction<number | null>) => {
            state.city = action.payload;
        },
        setSpecialSpecialty: (state, action: PayloadAction<number | null>) => {
            state.specialSpecialty = action.payload;
        },
        setTitle: (
            state,
            action: PayloadAction<"all" | "matab" | "online">
        ) => {
            state.title = action.payload;
        },
        resetFiltersSearch: (state) => {
            state.city = null;
            state.basicInsurance = null;
            state.specialty = null;
            state.specialSpecialty = null;
            state.title = "all";
        },
    },
});

export const {
    setBasicInsurance,
    setSpecialty,
    setCity,
    setSpecialSpecialty,
    setTitle,
    resetFiltersSearch,
} = selectionSlice.actions;

export default selectionSlice.reducer;
